import ValidationError from "../../classes/ValidationError";
import Model from "../../classes/model/Model";

/**
 * @property {int} id
 * @property {string} name
 * @property {string} content
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {Client} client
 * @property {TaskComment} comments
 * @property {User} responsible
 * @property {User} creator
 * @property {User} updater
 */
export default class Parameter extends Model {

    static getList() {

        return Parameter.getAxios().get(Parameter.getUrl('parameter/list')).then((response) => {
            return response.data;
        });
    }

    static getByName(name) {

        return this.getAxios().get(this.getUrl('parameter/get-by-name'), {
            params: {
                name
            },
        }).then(({data}) => {
            return new Parameter(data);
        });
    }

    static update(name, content) {

        return Parameter.getAxios().post(this.getUrl('parameter/update'), {name, content}).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

}
